import { createContext } from "react";

const ReportParamContext = createContext();

export default ReportParamContext;
